module.exports = __webpack_public_path__ + "3fbcdce84be9900b10df152504dc1e90.svg";